import { truncateText } from '../../lib'

interface ProductNameProps {
  name: string
  url: string
}

const NAME_CLASSES = 'text-2xl font-medium font-sec-font text-text-color h-[40px] overflow-hidden hover:no-underline hover:text-text-color active:text-text-color active:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-button-color focus-visible:ring-offset-2 visited:text-text-color visited:no-underline'

export function ProductName({ name, url }: ProductNameProps) {
  const displayName = truncateText(name)

  return (
    <a
      href={url}
      aria-label={name}
      className={NAME_CLASSES}
    >
      {displayName}
    </a>
  )
}
